export default __webpack_public_path__ + "static/media/mentorathand.4f706470.png";